const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_authenticated-user/oppdrag/$tluxCaseId/opprett-skjøte/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { routeLoaderApiClient } from "@/lib/api";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
export const Route = createFileRoute("/_authenticated-user/oppdrag/$tluxCaseId/opprett-skjøte/")({
  validateSearch: z.object({
    type: z.enum(["skjøte", "tresidig-skjøte"]).optional().default("skjøte")
  }),
  loaderDeps: ({
    search: {
      type
    }
  }) => ({
    type
  }),
  loader: async ({
    params,
    deps
  }) => {
    const {
      tluxCaseId
    } = params;
    const {
      type
    } = deps;
    const res = await routeLoaderApiClient.oppdrag[":tluxCaseId"].skjøte.defaults.$get({
      param: {
        tluxCaseId
      },
      query: {
        type
      }
    });
    if (res.ok === false) {
      throw new Error("Failed to fetch skjøte defaults");
    }
    return {
      skjøte: await res.json()
    };
  },
  head: ({
    loaderData
  }) => {
    // We can infer that this is a tresidig skjøte if we have any utsteder actors
    let skjøteType = "skjøte";
    if (loaderData != null) {
      skjøteType = loaderData.skjøte.document.utstederActorRegisterenhetAndelIndexes == null ? "skjøte" : "tresidig-skjøte";
    }
    return {
      meta: [{
        title: `Opprett ${skjøteType} | Alice & Bob`
      }]
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});